export enum FlowsLaunchDarklyFeatureFlags {
  MATCH_FLOW_SLUG = 'match-flow-slug',
  REMOVE_IN_PERSON = 'remove-in-person'
}
